import React from 'react';
import styles from './PostLoginRailIntro.module.css';

const overlayLabels = [
  { label: 'Brake Pressure', className: styles.telemetryTopLeft },
  { label: 'Thermal Index', className: styles.telemetryTopRight },
  { label: 'Response Delay', className: styles.telemetryBottomLeft },
  { label: 'System Health', className: styles.telemetryBottomRight },
];

export default function HeroTrain({ className = '', showTelemetry = true }) {
  return (
    <div className={`${styles.trainStage} ${className}`.trim()} aria-hidden="true">
      <div className={styles.trainGrid} />
      <div className={styles.trainAura} />
      {showTelemetry && overlayLabels.map((item) => (
        <div key={item.label} className={`${styles.telemetryLabel} ${item.className}`}>
          <span className={styles.telemetryDot} />
          <span>{item.label}</span>
        </div>
      ))}
      <div className={styles.trainSweep} />
      <svg
        viewBox="0 0 1280 560"
        className={styles.trainSvg}
        role="presentation"
        focusable="false"
      >
        <defs>
          <linearGradient id="trainBody" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#991b1b" />
            <stop offset="38%" stopColor="#dc2626" />
            <stop offset="72%" stopColor="#9f1239" />
            <stop offset="100%" stopColor="#450a0a" />
          </linearGradient>
          <linearGradient id="trainShadow" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="rgba(0,0,0,0.18)" />
            <stop offset="100%" stopColor="rgba(0,0,0,0.48)" />
          </linearGradient>
          <linearGradient id="windowBand" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#08111f" />
            <stop offset="50%" stopColor="#16273b" />
            <stop offset="100%" stopColor="#09111d" />
          </linearGradient>
          <linearGradient id="accentLine" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#67e8f9" stopOpacity="0.15" />
            <stop offset="50%" stopColor="#a5f3fc" stopOpacity="0.95" />
            <stop offset="100%" stopColor="#67e8f9" stopOpacity="0.15" />
          </linearGradient>
          <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="8" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        <path
          d="M70 356 C120 238, 270 182, 530 178 L1040 178 C1136 178, 1203 204, 1244 262
             L1258 286 C1268 300, 1270 320, 1263 336 C1248 372, 1206 390, 1145 396
             L446 426 C250 434, 134 414, 86 382 C69 370, 63 362, 70 356 Z"
          fill="url(#trainBody)"
        />
        <path
          d="M84 358 C121 266, 271 206, 544 200 L1032 200 C1125 200, 1183 220, 1216 270
             L1224 282 C1234 296, 1237 313, 1231 329 C1219 359, 1184 374, 1132 379
             L454 404 C271 411, 166 396, 113 373 C91 364, 79 358, 84 358 Z"
          fill="rgba(255,255,255,0.1)"
        />
        <path
          d="M107 334 C142 267, 281 226, 551 222 L1006 222 C1090 222, 1148 239, 1186 280
             L1194 289 C1202 298, 1204 309, 1199 320 C1190 341, 1163 352, 1118 357
             L457 381 C303 386, 189 381, 127 360 C106 353, 96 344, 107 334 Z"
          fill="url(#windowBand)"
        />
        <path
          d="M159 254 C252 211, 376 194, 552 192 L1014 192"
          stroke="rgba(255,255,255,0.24)"
          strokeWidth="8"
          strokeLinecap="round"
        />
        <path
          d="M158 394 C295 408, 425 408, 584 399 L1144 360"
          stroke="rgba(20,25,36,0.45)"
          strokeWidth="13"
          strokeLinecap="round"
        />
        <path
          d="M241 246 L1088 246"
          stroke="url(#accentLine)"
          strokeWidth="4"
          strokeLinecap="round"
          filter="url(#glow)"
        />
        <path
          d="M90 358 C144 276, 250 212, 391 182 C301 204, 218 254, 162 322
             C143 344, 116 358, 90 358 Z"
          fill="rgba(255,255,255,0.14)"
        />
        <path
          d="M1170 262 L1214 262"
          stroke="rgba(255,255,255,0.18)"
          strokeWidth="4"
          strokeLinecap="round"
        />
        {[278, 428, 578, 728, 878, 1028].map((x) => (
          <line
            key={x}
            x1={x}
            y1="229"
            x2={x}
            y2="351"
            stroke="rgba(255,255,255,0.12)"
            strokeWidth="3"
          />
        ))}
        {[280, 570, 860, 1110].map((x) => (
          <g key={x}>
            <circle cx={x} cy="429" r="41" fill="#0b1220" />
            <circle cx={x} cy="429" r="25" fill="#1f2937" />
            <circle cx={x} cy="429" r="7" fill="#67e8f9" />
          </g>
        ))}
        <ellipse cx="645" cy="469" rx="540" ry="24" fill="rgba(6,10,18,0.48)" />
      </svg>
    </div>
  );
}
